import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.jpg";
import projImg2 from "../assets/img/project-img2.jpg";
import projImg3 from "../assets/img/project-img3.jpg";
import colorSharp2 from "../assets/img/color-sharp2.jpg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';


export const Projects = () => {

  const projects = [
    {
      title: "Thrive Blog",
      description: "MERN Stack Web Application",
      imgUrl: projImg1,
      link: 'https://github.com/Nushwa/Thrive-Blog'
    },
    {
      title: "ProShop",
      description: "MERN Stack Web Application",
      imgUrl: projImg2,
      link: 'https://github.com/Nushwa/proshop'
    },
    {
      title: "Blood Source",
      description: "Final Year Project",
      imgUrl: projImg3,
      link: ''
    },
    
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>These projects are like my digital playground where I bring my ideas to life.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <p style={{fontSize: "23px", fontWeight: "200" }} >Side Projects</p>

                      <a className = "projectLinks" href="https://github.com/Nushwa/Malaria-Classification" target="_blank" rel="noreferrer">Malaria Classification</a> <br></br>
                      <a className = "projectLinks" href="https://github.com/Nushwa/robofriends" target="_blank" rel="noreferrer">Robofriends</a> <br></br>
                      <a className = "projectLinks" href="https://github.com/Nushwa/BankProject" target="_blank" rel="noreferrer">Bank Front End</a> <br></br>
                      <a className = "projectLinks" href="https://github.com/Nushwa/Blender-projects" target="_blank" rel="noreferrer">Blender Projects</a> <br></br>
                      <a className = "projectLinks" href="https://github.com/Nushwa/HotelProject" target="_blank" rel="noreferrer">Hotel Database using SQL</a> <br></br>
                      
                    </Tab.Pane>
                    
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" alt="Background with sharp geometric shapes." src={colorSharp2} />
    </section>
  )
}
